export default __webpack_public_path__ + "static/media/Punto_02_Fortezza_Vecchia_e_Darsena_Vecchia_SPA_Def.235b522e.aac";